import React from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
// data
import {
  eventFaqDefinition,
  formattedMiscEventFaqDefinitions
} from '../shared-components/faq/data/eventFaqDefinition';
import onEventFaqSubmit from './data/onEventFaqSubmit';
import { AV_MUSIC_FORM, EVENT_FAQ_CONST } from '../shared-components/faq/data/constants';
import { onEventFaqBlur, onEventFaqChange } from './data/onEventFaqChange';
import { hasQuantityAndDescription, mapBoolToString, pageInfo, seedValuesWithSelected } from './data/utils';
// faq component
import ButtonNavigation from '../app-faq-components/ButtonNavigation';
import ToggleFieldRow from '../app-faq-components/ToggleFieldRow';
import FaqHeader from '../app-faq-components/FaqHeader';
const { IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED, IS_AMPLIFIED_MUSIC_ALLOWED } = EVENT_FAQ_CONST;

const AvMusicForm = ({
  error,
  handleSubmit,
  intl,
  page,
  hasAmplifiedMusic,
  dispatch,
  spaceId,
  accessToken,
  showErrorToast,
  ...props
}) => {
  const header = intl.formatMessage(pageInfo(page).header);
  const Icon = pageInfo(page).icon;
  const avMusic = get(eventFaqDefinition, 'av_music', {});
  const {
    [IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED]: isConnectedAmplifiedMusicAllowed,
    ...equipmentRules } = get(avMusic, 'av_equipment_rules', {});
  const onChangeFn = onEventFaqChange(dispatch, spaceId, accessToken, showErrorToast);
  const onBlurFn = onEventFaqBlur(dispatch, spaceId, accessToken, showErrorToast);

  return (
    <form className="flex-basis-100" onSubmit={handleSubmit}>
      <FaqHeader header={header} icon={<Icon />} />
      <h6 className="questions-section">
        <FormattedMessage
          id="hosting.av_music_form.available_av_equipment"
          defaultMessage="Available AV equipment"
        />
      </h6>
      {
        Object.keys(avMusic.provided_av_equipment).map((key) => (
          <>
            <ToggleFieldRow
              label={avMusic.provided_av_equipment[key]}
              formName={AV_MUSIC_FORM}
              hasQuantity={props[`${key}_quantity`]}
              hasDescription={props[`${key}_description`]}
              placeholder={avMusic.provided_av_equipment[key].placeholder}
              fieldName={key}
              dispatch={props.dispatch}
              onChange={onChangeFn}
              onBlur={onBlurFn}
            />
            <hr />
          </>
        ))
      }
      <div className="text-small text-gray-600">
        { formattedMiscEventFaqDefinitions.amenities_note }
      </div>
      <h6 className="questions-section">
        <FormattedMessage
          id="hosting.av_music_form.av_music_rules"
          defaultMessage="Rules for AV and music"
        />
      </h6>
      <div>
        {
          Object.keys(equipmentRules).map((key) => (
            <>
              <ToggleFieldRow
                label={avMusic.av_equipment_rules[key]}
                formName={AV_MUSIC_FORM}
                fieldName={key}
                dispatch={props.dispatch}
                onChange={onChangeFn}
              />
              {
                (IS_AMPLIFIED_MUSIC_ALLOWED === key && hasAmplifiedMusic) &&
                <div className="margin-lg-top">
                  <ToggleFieldRow
                    label={avMusic.av_equipment_rules[IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED]}
                    formName={AV_MUSIC_FORM}
                    fieldName={IS_CONNECTED_AMPLIFIED_MUSIC_ALLOWED}
                    dispatch={props.dispatch}
                    onChange={onChangeFn}
                  />
                </div>
              }
              <hr />
            </>
          ))
        }
      </div>
      <div className="text-danger text-small margin-xl-bottom">{error}</div>
      <ButtonNavigation {...props} dispatch={dispatch} spaceId={spaceId} />
    </form>
  );
};

AvMusicForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.string,
  parkingToggleFieldValue: PropTypes.string,
  intl: intlShape,
  dispatch: PropTypes.func,
  spaceId: PropTypes.string,
  accessToken: PropTypes.string,
  showErrorToast: PropTypes.bool,
  page: PropTypes.string,
  hasAmplifiedMusic: PropTypes.bool
};

const config = {
  form: AV_MUSIC_FORM,
  onSubmit: onEventFaqSubmit
};

const selector = formValueSelector(AV_MUSIC_FORM);

function mapStateToProps (state, { eventFaq }) {
  const avMusic = get(eventFaqDefinition, 'av_music.provided_av_equipment', {});
  const initialValues = mapBoolToString(seedValuesWithSelected(eventFaq));
  const hasAmplifiedMusic = 'true' === (selector(state, IS_AMPLIFIED_MUSIC_ALLOWED) || false);
  const itemSelected = hasQuantityAndDescription(Object.keys(avMusic), selector, state);
  return {
    hasAmplifiedMusic,
    ...itemSelected,
    initialValues
  };
}

export default connect(mapStateToProps)(reduxForm(config)(injectIntl(AvMusicForm)));
